/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper";
import { resetBeneBankData } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import TextInputField from "../../../_utils/CommonInputFields/TextInputField";

const BankDetails = (props) => {
  const { previewMode = false, setShowDetails = () => {} } = props;
  const { manualVirtualAccount = false, setManualVirtualAccount = () => {} } =
    props;

  const isBankError = useSelector(
    (state) => state.beneAllVerification.isBankError,
  );
  const isBankMessage = useSelector(
    (state) => state.beneAllVerification.bankMessage,
  );
  const bankStatus = useSelector(
    (state) => state.beneAllVerification.verifyBank,
  );

  const bankStatusLoading = useSelector(
    (state) => state.beneAllVerification.verifyBankisLoading,
  );

  const [customErrors, setCustomErrors] = useState({});

  const dispatch = useDispatch();
  const [accFocused, setAccFocused] = useState(false);
  const [ifscFocused, setIfscFocused] = useState(false);

  const modifyValue = (type, value) => {
    if (
      type === "pan_no" ||
      type === "bank_account" ||
      type === "ifsc_code" ||
      type === "gstin"
    ) {
      return value?.toUpperCase();
    }
    if (type === "email_id") {
      return value?.toLowerCase();
    }
    return value;
  };

  const allowedValue = (name, value) => {
    if (name === "bank_account") return Validation.allowedBankAccNum(value);
    if (name === "ifsc_code") return Validation.allowedBankIfsc(value);
    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "ifsc_code")
      errors = Validation.validateIfsc(name, value, errors);
    if (name === "bank_account")
      errors = Validation.validateBankAcc(name, value, errors);
    setCustomErrors(errors);
  };

  useEffect(() => {
    if (isBankError === true) {
      props.BenEnableNextButton(true);
      props?.setVirtualAccount(false);
    }
  }, [isBankError]);

  const handleChange = (e) => {
    setManualVirtualAccount(false);
    setShowDetails(false);
    props.setPayload({
      ...props.payload,
      virtual: "",
    });
    let { name, value } = e.target;
    value = modifyValue(name, value);
    if (allowedValue(name, value)) {
      validateAndRecordError(name, value);
      let newObj;
      if (name === "bank_account") {
        newObj = { ...props.payload, [name]: value, ifsc_code: "" };
        props?.setBankVerificationStatus(false);
      } else {
        newObj = { ...props.payload, [name]: value };
        dispatch(resetBeneBankData());
        props?.setVirtualAccount(false);
        props?.setBankLookupNext(false);
        if (!value || value.length < 11) {
          props?.setBankVerificationStatus(false);
        }
      }

      props.setPayload(newObj);
    }
    if (props.payload.bank_account?.length === 0) {
      props?.setBankVerificationStatus(false);
      props?.setVirtualAccount(false);
    }

    if (
      props.payload.ifsc_code?.length === 0 ||
      props.payload.ifsc_code?.length < 11
    ) {
      props?.setBankVerificationStatus(false);
    }
  };

  useEffect(() => {
    if (isBankError === true && manualVirtualAccount === true) {
      props.setPayload({
        ...props.payload,
        virtual: true,
      });
    }
    if (isBankError === true) {
      props.setPayload({ ...props.payload, skip_account_verification: "Y" });
      if (manualVirtualAccount === false) {
        props?.setBankVerificationStatus(false);
      }
      props?.BenEnableNextButton(true);
    }

    if (bankStatus?.status === true) {
      let errors = { ...customErrors };
      delete errors["bank_account"];
      setCustomErrors(errors);
      props.setPayload({
        ...props.payload,
        acc_holder_name: bankStatus?.verification_details[0].full_name,
        skip_account_verification: "N",
      });
      props?.setBankVerificationStatus(true);
      if (!bankStatusLoading && props.bankLookupNext) {
        props?.BenEnableNextButton(false);
      }
      props?.setVirtualAccount(false);
    }
    if (
      bankStatus?.status === true &&
      bankStatus?.verification_details[0].is_virtual === "Y"
    ) {
      props?.setVirtualAccount(true);
      props.setPayload({
        ...props.payload,
        acc_holder_name: bankStatus?.verification_details[0].legal_name,
      });
    }
  }, [bankStatus]);

  useEffect(() => {
    if (customErrors["bank_account"]) {
      props?.setBankVerificationStatus(false);
    }
    if (customErrors["ifsc_code"]) {
      props?.setBankVerificationStatus(false);
    }
    if (!bankStatusLoading && customErrors["ifsc_code"]) {
      props?.setBankLookupNext(false);
    }
  }, [customErrors]);

  // useEffect(() => {
  //   props.setBankUserInfo([
  //     {
  //       branch: bankStatus?.verification_details[0].branch
  //         ? bankStatus?.verification_details[0].branch.toLowerCase()
  //         : props?.ifscData
  //           ? props?.ifscData?.branch.toLowerCase()
  //           : "N/A",
  //       city: bankStatus?.verification_details[0].city
  //         ? bankStatus?.verification_details[0].city.toLowerCase()
  //         : props?.ifscData
  //           ? props?.ifscData?.city.toLowerCase()
  //           : "N/A",
  //       district: bankStatus?.verification_details[0].district
  //         ? bankStatus?.verification_details[0].district.toLowerCase()
  //         : props?.ifscData
  //           ? props?.ifscData?.district.toLowerCase()
  //           : "N/A",
  //       address: bankStatus?.verification_details[0].address
  //         ? bankStatus?.verification_details[0].address.toLowerCase()
  //         : props?.ifscData
  //           ? props?.ifscData?.address.toLowerCase()
  //           : "N/A",
  //     },
  //   ]);
  // }, [bankStatus, dispatch]);

  useEffect(() => {
    const details = bankStatus?.verification_details?.[0] || {};
    const ifsc = props?.ifscData || {};

    props.setBankUserInfo([
      {
        branch:
          details?.branch?.toLowerCase() || ifsc?.branch?.toLowerCase() || "",
        city: details?.city?.toLowerCase() || ifsc?.city?.toLowerCase() || "",
        district:
          details?.district?.toLowerCase() ||
          ifsc?.district?.toLowerCase() ||
          "",
        address:
          details?.address?.toLowerCase() || ifsc?.address?.toLowerCase() || "",
      },
    ]);
  }, [bankStatus, props?.ifscData]);

  const bankValuesFilled = () => {
    return (
      props.payload.bank_account?.length >= 9 &&
      props.payload.ifsc_code?.length === 11 &&
      /^[A-Z]{4}0[A-Z0-9]{6}$/.test(props.payload.ifsc_code)
    );
  };

  const getBankVerifiedElementDiv = (isLoading, bankDetails, ifscDetails) => {
    return (
      <div className={`w-full flex flex-col self-center gap-gap-md`}>
        <TextInputField
          variant={
            (!isLoading &&
              props?.bankVerificationStatus &&
              bankDetails.value?.length >=
                GlobalConfiguration?.lengthCheckFour &&
              ifscDetails.value?.length === GlobalConfiguration?.ifscLength) ||
            (isBankError === true && manualVirtualAccount === true)
              ? "verified"
              : !isLoading &&
                  bankDetails.value?.length >
                    GlobalConfiguration?.lengthCheckFour &&
                  isBankError
                ? "error"
                : accFocused
                  ? "typing"
                  : "default"
          }
          placeholder={bankDetails.label}
          fontKind={"big"}
          bgColor="var(--primary-card)"
          fgColor="var(--text-primary)"
          value={bankDetails.value}
          name={bankDetails.name}
          onInput={handleChange}
          isFullWidth={true}
          adornment={
            isLoading
              ? "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
              : undefined
          }
          onFocus={(e) => setAccFocused(true)}
          onBlur={(e) => setAccFocused(false)}
          isDisabled={props?.type === "switch_account"}
        />

        <TextInputField
          variant={
            (!isLoading &&
              props?.bankVerificationStatus &&
              ifscDetails.value?.length === GlobalConfiguration?.ifscLength) ||
            (isBankError === true && manualVirtualAccount === true)
              ? "verified"
              : !isLoading &&
                  (customErrors["ifsc_code"] || isBankError) &&
                  ifscDetails.value?.length === GlobalConfiguration?.ifscLength
                ? "error"
                : ifscFocused
                  ? "typing"
                  : "default"
          }
          placeholder={ifscDetails.label}
          fontKind={"big"}
          bgColor="var(--primary-card)"
          fgColor="var(--text-primary)"
          value={ifscDetails.value}
          name={ifscDetails.name}
          onInput={handleChange}
          isDisabled={
            bankDetails.value?.length <
              GlobalConfiguration?.accountnormalLength ||
            props?.type === "switch_account"
          }
          isFullWidth={true}
          adornment={
            isLoading
              ? "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
              : undefined
          }
          onFocus={(e) => setIfscFocused(true)}
          onBlur={(e) => setIfscFocused(false)}
        />
      </div>
    );
  };

  const bankVerificationDiv = () => {
    return (
      <div className="w-full">
        {getBankVerifiedElementDiv(
          bankStatusLoading,
          {
            name: "bank_account",
            status: props?.props?.bankVerificationStatus,
            label: "Bank account number",
            value: props.payload.bank_account,
          },
          {
            name: "ifsc_code",
            status: props?.props?.bankVerificationStatus,
            label: "IFSC code",
            value: props.payload.ifsc_code,
          },
        )}
      </div>
    );
  };

  if (previewMode) {
    const details = bankStatus?.verification_details?.[0];

    return (
      <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
        <div className="text-text-primary text-font-md">
          <span className="font-semibold">Bank Details</span>
        </div>

        <div className="flex flex-col gap-gap-sm">
          {/* Account Number */}
          <div className="flex flex-col gap-gap-xs">
            <div className="text-text-primary font-normal text-font-md truncate">
              {props?.payload?.bank_account || "Not Given"}
            </div>
            <div className="text-font-xs text-text-secondary">
              Bank account number
            </div>
          </div>

          {/* IFSC */}
          <div className="flex flex-col gap-gap-xs">
            <div className="text-text-primary font-normal text-font-md truncate">
              {props?.payload?.ifsc_code || "Not Given"}
            </div>
            <div className="text-font-xs text-text-secondary">IFSC code</div>
          </div>

          {/* Verified Info */}
          {details && props?.payload?.skip_account_verification === "N" && (
            <>
              <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>

              <div className="flex flex-col gap-gap-xs">
                <div className="text-text-primary capitalize text-font-md">
                  {details?.full_name?.toLowerCase() || "N/A"}
                </div>
                <div className="text-font-xs text-text-secondary">
                  Account holder's name
                </div>
              </div>

              <div className="flex flex-col gap-gap-xs">
                <div className="text-text-primary capitalize text-font-md">
                  {details?.branch?.toLowerCase() || "N/A"}
                </div>
                <div className="text-font-xs text-text-secondary">Branch</div>
              </div>

              <div className="flex flex-col gap-gap-xs">
                <div className="text-text-primary capitalize text-font-md">
                  {details?.city?.toLowerCase() || "N/A"}
                </div>
                <div className="text-font-xs text-text-secondary">City</div>
              </div>

              <div className="flex flex-col gap-gap-xs">
                <div className="text-text-primary capitalize text-font-md">
                  {details?.district?.toLowerCase() || "N/A"}
                </div>
                <div className="text-font-xs text-text-secondary">District</div>
              </div>

              <div className="flex flex-col gap-gap-xs">
                <div
                  className="text-text-primary capitalize text-font-md"
                  style={{ wordWrap: "break-word" }}
                >
                  {details?.address?.toLowerCase() || "N/A"}
                </div>
                <div className="text-font-xs text-text-secondary">Address</div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`flex flex-col overflow-hidden rounded-border-radius-md z-z-index-content ${
        props?.virtualAccount && props?.isIFSCValid ? "Qlg:mb-margin-base" : ""
      }`}
    >
      <div
        className={`relative z-z-index-content ${
          bankValuesFilled() &&
          props.activeStep !== 3 &&
          props?.bankVerificationStatus &&
          !customErrors["bank_account"] &&
          bankStatus?.verification_details?.length > 0
            ? "rounded-t-border-radius-md"
            : "rounded-border-radius-md"
        }`}
      >
        <div
          className={`absolute w-width-full py-padding-md bottom-bottom-base transition-all duration-animation-fast ease-in-out transform ${
            (bankValuesFilled() &&
              props.activeStep !== 3 &&
              props?.bankVerificationStatus &&
              !customErrors["bank_account"] &&
              bankStatus?.verification_details?.length > 0) ||
            (bankValuesFilled() && props.activeStep !== 3 && isBankError)
              ? "rounded-b-none"
              : "rounded-b-border-radius-md"
          }`}
          style={{
            backgroundColor:
              (bankValuesFilled() &&
                props?.bankVerificationStatus &&
                !isBankError) ||
              (isBankError && manualVirtualAccount)
                ? "var(--positive-card)"
                : bankValuesFilled() &&
                    !props?.bankVerificationStatus &&
                    isBankError
                  ? "var(--negative-card)"
                  : "transparent",
          }}
        ></div>
        <div className="bg-primary-card rounded-t-border-radius-md flex flex-row justify-between px-padding-md py-padding-md text-text-primary text-font-md font-semibold">
          Bank Details
        </div>
        <div
          className={`flex flex-col bg-primary-card rounded-b-border-radius-md relative`}
        >
          <div className="w-width-full flex flex-col px-padding-md pb-padding-md bg-primary-card rounded-b-border-radius-md">
            {props.activeStep !== 3 ? (
              <div className="w-width-full">{bankVerificationDiv()}</div>
            ) : (
              <div className="flex flex-col gap-gap-lg pb-padding-button-l">
                <div>
                  <div
                    className="w-width-full
                    antaliased font-normal text-text-primary capitalize self-center
                    text-font-lg truncate ..."
                  >
                    {props?.payload?.bank_account}
                  </div>
                  <div className="antaliased text-text-secondary text-font-xs opacity-dark-opacity">
                    Bank account number
                  </div>
                </div>
                <div>
                  <div
                    className="w-width-full
                    antaliased font-normal text-text-primary capitalize self-center
                    text-xl 3xl:text-2xl 5xl:text-3xl truncate ..."
                  >
                    {props?.payload?.ifsc_code}
                  </div>
                  <div className="antaliased text-text-secondary text-font-xs opacity-dark-opacity">
                    IFSC code
                  </div>
                </div>
                {props.payload.skip_account_verification === "N" ? (
                  <>
                    <div className="h-[var(--border)] bg-white px-padding-lg opacity-dark-opacity"></div>
                    <div className="flex justify-between">
                      <div className="antaliased font-normal text-text-primary capitalize self-center text-xl">
                        {bankStatus?.verification_details[0]?.full_name.toLowerCase()}
                      </div>
                      <div className="antaliased text-text-secondary text-font-xs opacity-dark-opacity">
                        Account holders name
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="h-[var(--border)] bg-text-primary px-padding-lg opacity-dark-opacity"></div>
                    <div className="flex flex-row justify-between items-center gap-gap-button-m">
                      <div className="h-full flex flex-col justify-between p-padding-xs text-text-primary text-font-md">
                        <div className="text-md font-extrabold">
                          SKIPPING VERIFICATION
                        </div>
                      </div>
                      <div className="flex flex-col">
                        <img
                          className="w-icon-md h-icon-md"
                          src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                          alt="verified logo"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className={`transition-transform duration-animation-fast ease-in-out transform ${
          (bankValuesFilled() &&
            props.activeStep !== GlobalConfiguration?.lengthCheckThree &&
            props?.bankVerificationStatus &&
            !customErrors["bank_account"] &&
            bankStatus?.verification_details?.length >
              GlobalConfiguration?.lengthCheckZero) ||
          (isBankError && manualVirtualAccount && props?.ifscData)
            ? "translate-y-0 opacity-base-opacity"
            : "-translate-y-full opacity-opacity-none"
        }`}
      >
        {bankValuesFilled() &&
        props.activeStep !== GlobalConfiguration?.lengthCheckThree &&
        props?.bankVerificationStatus &&
        !customErrors["bank_account"] &&
        bankStatus?.verification_details?.length >
          GlobalConfiguration?.lengthCheckZero ? (
          <div className="bg-primary-nav rounded-b-border-radius-md">
            <div className="rounded-b-border-radius-md flex flex-row bg-positive-card relative z-z-index-content">
              <div className="mt-margin-sm w-width-full">
                <div className="flex whitespace-nowrap px-padding-md text-ellipsis gap-gap-sm text-font-md font-font-normal text-text-primary items-start">
                  <img
                    className="w-icon-md h-icon-md mt-margin-xs"
                    src="https://q2pay.in/new_assets/common/create_flow/verified_with_white_circle_green.svg"
                    alt="verified logo"
                  />
                  <div className="flex flex-col gap-gap-xs">
                    <div className="w-auto overflow-hidden text-ellipsis capitalize text-text-primary break-words whitespace-normal">
                      {(props?.virtualAccount
                        ? props?.payload?.legalName
                        : bankStatus?.verification_details?.[0]?.full_name
                      )?.toLowerCase()}
                    </div>
                    <div className="text-font-xs text-text-primary font-normal">
                      {props?.virtualAccount
                        ? "Account holder's name - using legal name"
                        : "Account holder's name"}
                    </div>
                  </div>
                </div>

                <div className="flex justify-end">
                  <div className="rounded-br-border-radius-md rounded-tl-border-radius-md bg-text-primary flex items-center justify-around">
                    <div className="antialiased p-padding-sm">
                      <div className="w-banklogo-width-lg h-banklogo-height-lg flex-shrink-0">
                        <IfscCodeMapper ifscCode={props?.payload?.ifsc_code} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-primary-nav rounded-b-border-radius-md flex w-width-full flex-col gap-gap-sm justify-between overflow-hidden py-padding-sm px-padding-md">
              <div className="text-font-md font-normal text-text-primary">
                Address Details
              </div>
              <div className="flex flex-col gap-gap-sm">
                <div className="flex flex-col gap-gap-xs">
                  <div className="text-font-md font-normal text-text-primary capitalize">
                    {bankStatus?.verification_details[0].branch
                      ? bankStatus?.verification_details[0].branch.toLowerCase()
                      : "N/A"}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    Branch
                  </div>
                </div>
                <div className="flex flex-col gap-gap-xs">
                  <div className="text-font-md font-normal text-text-primary capitalize">
                    {bankStatus?.verification_details[0].city
                      ? bankStatus?.verification_details[0].city.toLowerCase()
                      : "N/A"}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    City
                  </div>
                </div>
                <div className="flex flex-col gap-gap-xs">
                  <div className="text-font-md font-normal text-text-primary capitalize">
                    {bankStatus?.verification_details[0].district
                      ? bankStatus?.verification_details[0].district.toLowerCase()
                      : "N/A"}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    District
                  </div>
                </div>
                <div className="flex flex-col gap-gap-xs">
                  <div
                    className="text-font-md font-normal text-text-primary capitalize"
                    style={{
                      wordWrap: "break-word",
                      textWrap: "wrap",
                    }}
                  >
                    {bankStatus?.verification_details[0].address
                      ? bankStatus?.verification_details[0].address.toLowerCase()
                      : "N/A"}{" "}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    Address
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : isBankError && manualVirtualAccount && props?.ifscData ? (
          <>
            <div className="bg-primary-nav rounded-b-border-radius-md">
              <div className="rounded-b-border-radius-md flex flex-row bg-positive-card relative z-z-index-content">
                <div className="mt-margin-sm w-width-full">
                  <div className="flex whitespace-nowrap px-padding-md text-ellipsis gap-gap-sm text-font-md font-font-normal text-text-primary items-start">
                    <img
                      className="w-icon-md h-icon-md mt-margin-xs"
                      src="https://q2pay.in/new_assets/common/create_flow/verified_with_white_circle_green.svg"
                      alt="verified logo"
                    />
                    <div className="flex flex-col gap-gap-xs">
                      <div className="w-auto overflow-hidden text-ellipsis capitalize text-text-primary break-words whitespace-normal">
                        {props?.payload?.legalName?.toLowerCase() || "N/A"}
                      </div>
                      <div className="text-font-xs text-text-secondary">
                        Account holder's name - using legal name
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <div className="rounded-br-border-radius-md rounded-tl-border-radius-md bg-text-primary flex items-center justify-around">
                      <div className="antialiased p-padding-sm">
                        <div className="w-banklogo-width-lg h-banklogo-height-lg flex-shrink-0">
                          <IfscCodeMapper ifscCode={props?.ifscData?.ifsc} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-primary-nav rounded-b-border-radius-md flex w-width-full flex-col gap-gap-sm justify-between overflow-hidden py-padding-sm px-padding-md">
                <div className="text-font-md font-normal text-text-primary">
                  Address Details
                </div>
                <div className="flex flex-col gap-gap-sm">
                  <div className="flex flex-col gap-gap-xs">
                    <div className="text-font-md font-normal text-text-primary capitalize">
                      {props?.ifscData?.branch.toLowerCase() ?? "N/A"}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      Branch
                    </div>
                  </div>
                  <div className="flex flex-col gap-gap-xs">
                    <div className="text-font-md font-normal text-text-primary capitalize">
                      {props?.ifscData?.city.toLowerCase() ?? "N/A"}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      City
                    </div>
                  </div>
                  <div className="flex flex-col gap-gap-xs">
                    <div className="text-font-md font-normal text-text-primary capitalize">
                      {props?.ifscData?.district.toLowerCase() ?? "N/A"}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      District
                    </div>
                  </div>
                  <div className="flex flex-col gap-gap-xs">
                    <div
                      className="text-font-md font-normal text-text-primary capitalize"
                      style={{
                        wordWrap: "break-word",
                        textWrap: "wrap",
                      }}
                    >
                      {props?.ifscData?.address.toLowerCase() ?? "N/A"}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      Address
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      <div
        className={`transition-transform duration-animation-fast ease-in-out transform ${
          bankValuesFilled() &&
          props.activeStep !== GlobalConfiguration?.lengthCheckThree &&
          isBankError &&
          !manualVirtualAccount
            ? "translate-y-0 opacity-base-opacity"
            : "-translate-y-full opacity-opacity-none"
        }`}
      >
        {bankValuesFilled() &&
        props.activeStep !== GlobalConfiguration?.lengthCheckThree &&
        isBankError &&
        !manualVirtualAccount ? (
          <div className="relative">
            <div className="bg-emphasis flex flex-col h-full">
              <div className="bg-negative-card px-padding-md py-padding-sm flex rounded-b-border-radius-md">
                <div className="flex flex-row items-start gap-gap-button-m">
                  <div className="flex flex-col flex-shrink-0">
                    <img
                      className="w-icon-md h-icon-md mt-margin-xs"
                      src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                      alt="verified logo"
                    />
                  </div>

                  <div className="h-height-full flex flex-col justify-between text-text-primary text-base">
                    <div className="text-font-md font-normal">
                      Verification failed
                    </div>
                    {isBankError === true &&
                    props?.ownerAccIfscError === false &&
                    !props?.ownerAccIfscLoading ? (
                      <>
                        <p className=" text-text-secondary text-font-sm font-normal">
                          This account cannot be verified. It can still be used
                          by making it a virtual account.
                        </p>
                      </>
                    ) : (
                      <>
                        <ul className="list-disc flex flex-col text-font-xs pl-padding-md">
                          <li>Account could not be verified</li>
                          <li>Crosscheck the information given above</li>
                        </ul>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-emphasis w-width-full mx-auto rounded-b-border-radius-md flex px-padding-md py-padding-sm text-text-primary">
              <div className="flex items-start flex-col gap-gap-xs">
                <div className="text-font-md font-semibold">Bank remark : </div>
                <div className="text-font-xs">{isBankMessage}</div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default BankDetails;
